export const PRINT_SAFE_CSS = `@page {
  margin: 0;
}

body {
  margin: 0;
}

* {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}`;

export function injectPrintStyles(html: string): string {
  const styleTag = `<style data-react-pdf-engine-print>${PRINT_SAFE_CSS}</style>`;

  if (/<\/head>/i.test(html)) {
    return html.replace(/<\/head>/i, `${styleTag}\n</head>`);
  }

  if (/<head\b[^>]*>/i.test(html)) {
    return html.replace(/<head\b[^>]*>/i, (match) => `${match}\n${styleTag}`);
  }

  if (/<html\b[^>]*>/i.test(html)) {
    return html.replace(
      /<html\b[^>]*>/i,
      (match) => `${match}\n<head>${styleTag}</head>`
    );
  }

  return `${styleTag}\n${html}`;
}
